import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

const validatorHasEventOrganizer = {
  getMessage (field, args) {
    return 'Event Organizer must be defined'
  },
  validate (value, args) {
    var rule = value.organizerId > 0
    return rule
  }
}

export default validatorHasEventOrganizer
